import { useTranslations } from 'next-intl';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import { usePresentationContext } from '../../../legacy-context/presentationContext';

export const Screenshot = () => {
  const t = useTranslations('presenting');
  const { useQfa } = usePresentationContext();
  const { totalQuestions, totalUpvotes } = useQfa();
  return (
    <Box>
      <Text
        fontWeight="semiBold"
        color="text"
        lineHeight="heading"
        fontFamily="heading"
        fontSize={13}
      >
        {t('questions_from_audience.qfa_number_of_questions', {
          count: totalQuestions,
        })}
        <br />
        {t('questions_from_audience.qfa_number_of_upvotes', {
          count: totalUpvotes,
        })}
      </Text>
    </Box>
  );
};
